// extracted by mini-css-extract-plugin
module.exports = {"required":"styles_required__pSCwB","text":"styles_text__lbgU7"};